import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: _ctx.type,
    prop: _ctx.prop
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_date_picker, {
        type: "date",
        placeholder: `请选择${_ctx.type}`,
        "start-placeholder": "",
        modelValue: _ctx.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event)),
        disabled: _ctx.disabled,
        onChange: _ctx.changeTime
      }, null, 8, ["placeholder", "modelValue", "disabled", "onChange"])
    ]),
    _: 1
  }, 8, ["label", "prop"]))
}